<template>
    <div>
        <div class="card relative mb-6 rounded-xl" @click="goToPage(item.url)">
            <img :src="item.imageUrl" class="w-full max-w-full h-auto rounded-xl" alt />
            <div
                class="label absolute -bottom-3 right-6 h-7 w-auto text-center text-base text-white py-2px px-4 uppercase"
            >{{ item.line1 }}</div>
        </div>
        <!-- <div class="card relative mb-6 rounded-xl"> -->
            <!-- <img :src="item.imageUrl" class="w-full max-w-full h-auto" alt /> -->
            <!-- <div class="campaign-image-ultimate-service rounded-xl"></div> -->
            <!-- <div
                class="label absolute -bottom-3 right-6 h-7 w-auto text-center text-base text-white py-2px px-4 uppercase"
            >Ultimate Service</div> -->
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    name: "CardPrivilegesItem",
    props: {
        item: {
            type: Object
        }
    },
    methods: {
        goToPage: function (page) {
            this.setTracking(page);
            this.$router.push(page);
        },
        setTracking: function(page){
            let trackCategory = 'card_privilege';
            let trackAction = page == '/platinum-service'
                ? 'click_platinum_service'
                : 'click_ultimate_service';
            this.tracking.event(trackCategory, trackAction, null, null);

        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/image.scss";

.card {
    object-fit: contain;
    // box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
    .label {
        background-image: url("~@/assets/button/bg.svg");
        background-size: 100%;
    }

    img {
        margin: auto;
    }

    .campaign-image-platunum-service {
        @include boxRatio($ratio: 33.33%);
        // background-image: url("~@/assets/img/bg/platunum-service.png");
        background-image: url("~@/assets/img/bg/platinum-service-2.jpg");
    }

    .campaign-image-ultimate-service {
        @include boxRatio($ratio: 33.33%);
        background-image: url("~@/assets/img/bg/ultimate-service.png");
    }
}
</style>
